import { createContext, useContext, useEffect, useMemo } from "react";
import { capitalCase } from "change-case";
// firestore
import { onAuthStateChanged, signInWithCustomToken } from "firebase/auth";
import { auth } from "../services/firebase";
// hooks
import useCustomReducer from "../hooks/useCustomReducer";
// auth
import reducer, { initialAuthState } from "../reducers/authReducer";
import actionTypes from "../common/actionTypes";
import { VersionStoreContext } from "./VersionStoreContext";

// auth constants
const SHOPIFY_DOMAIN = ".myshopify.com";

const AuthContext = createContext({
  ...initialAuthState,
});

const AuthProvider = ({ children }) => {
  const [state, dispatch] = useCustomReducer(reducer, initialAuthState);

  const { accessToken } = useContext(VersionStoreContext);
  console.log("accessToken", accessToken);
  useEffect(() => {
    if (!accessToken) return;

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const token = await user.getIdToken(true);

        if (token) {
          dispatch({
            type: actionTypes.SET_FIREBASE_AUTH_ID_TOKEN,
            payload: token,
          });
        }

        dispatch({
          type: actionTypes.SET_USER_TO_STORE,
          payload: {
            user: {
              name: capitalCase(user.uid.split(SHOPIFY_DOMAIN)[0].replaceAll("-", " ")),
              domain: user.uid,
            },
          },
        });
      }
    });

    signInWithCustomToken(auth, accessToken);

    return () => {
      unsubscribe();
    };
  }, [accessToken, dispatch]);

  const memoizedState = useMemo(() => state, [state]);

  return <AuthContext.Provider value={memoizedState}>{children}</AuthContext.Provider>;
};

export { AuthContext, AuthProvider };
